var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t("contract_1")))]),_c('p',{staticClass:"terms"},[_c('span',{domProps:{"innerHTML":_vm._s( _vm.$t('contract_2') )}})])])}
var staticRenderFns = []

export { render, staticRenderFns }